import React, { Component } from 'react';

//styles and icons
import { Row, Col } from 'react-bootstrap';
import { Fab } from '@material-ui/core';
import ClearIcon from '@material-ui/icons/Clear';
import DoneIcon from '@material-ui/icons/Done';

// this component represents the save and cancel buttons of the video recorder addons.

export default class SaveChanges extends Component {
    handleSave = () =>{
        this.props.callbackFromParent("save");
    }
    handleClear = () =>{
        this.props.callbackFromParent("clear");
    }
    render() {
        return (
            <div>
                <div
                    className="p-absolute w-100 text-center saveChanges d-none"
                    style={{ top: '1rem' }}
                >
                    <Row className="row m-0 justify-content-center align-items-center">
                        <Col xl={2} md={2} xs={3} className="text-right pr-1">
                            <Fab 
                                onClick={this.handleClear}
                                style={{ height: '2.5rem', width: '2.5rem', fontSize: '1rem', cursor:"pointer" }}
                                className="rounded-circle btn-cancel-addone  text-right bg-dark-transperant p-2 border-0 text-white"
                                >
                                     <ClearIcon />
                            </Fab>
                        </Col>
                        <Col xl={2} md={2} xs={3} className="text-left pl-1">
                            <Fab 
                                onClick={this.handleSave}
                                style={{ height: '2.5rem', width: '2.5rem', fontSize: '1rem', cursor:"pointer" }}
                                className="rounded-circle btn-save-addone  text-left bg-dark-transperant p-2 border-0 text-white pulse"
                                >
                                    <DoneIcon /> 
                            </Fab>
                        </Col>
                    </Row>
                </div>
            </div>
        )
    }
}